import { ArrowLeft } from 'lucide-react';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import './list-page.css';

export interface ListPageHeaderProps {
  title: string;
  /** Small line above the title, e.g. `Customers › Gift cards`. */
  crumb?: string;
  /** Route the back arrow returns to. Omit to hide the arrow. */
  backTo?: string;
  backLabel?: string;
  actions?: ReactNode;
  below?: ReactNode;
}

export function ListPageHeader({
  title,
  crumb,
  backTo,
  backLabel = 'Back',
  actions,
  below,
}: ListPageHeaderProps) {
  return (
    <header className="nb-listpage-header">
      <div className="nb-listpage-header-row">
        {backTo && (
          <Link to={backTo} aria-label={backLabel} className="nb-listpage-back">
            <ArrowLeft size={18} />
          </Link>
        )}
        <div className="nb-listpage-heading">
          {crumb && <div className="nb-eyebrow nb-listpage-crumb">{crumb}</div>}
          <h1 className="nb-display nb-listpage-title">{title}</h1>
        </div>
        {actions && <div className="nb-listpage-actions">{actions}</div>}
      </div>
      {below && <div className="nb-listpage-below">{below}</div>}
    </header>
  );
}
